import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { applyTheme, readThemePreference } from './theme';

// Thème appliqué avant le premier rendu (US-24) : le faire dans un effet
// produirait un éclair de thème système au chargement.
applyTheme(readThemePreference());

const root = document.getElementById('root');
if (!root) throw new Error('#root introuvable');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service worker (US-08 : mode cuisine fonctionnel hors connexion, §2
// CLAUDE.md). Absent de jsdom (tests) : l'enregistrement ne s'exécute donc
// jamais pendant `npm test`, pas de garde supplémentaire nécessaire.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Enregistrement raté (navigateur restrictif, contexte non sécurisé en
      // développement…) : dégradation silencieuse, l'application reste
      // utilisable en ligne.
    });
  });
}
